import React, { ReactElement } from "react";
import styles from "./contactUs.module.scss";
import colors from "@styles/variables/vpnpricecomparisonVariables.module.scss";
import ContactUsForm from "@components/shared/contactUs/contactUsForm";

export default function ContactUs(): ReactElement {
    return (
        <section className={styles["contact-us"]}>
            <div className="flex flex-col lg:flex-row">
                <div className="flex flex-col justify-center lg:w-2/5  mb-8">
                    <div className="flex flex-col mb-8">
                        <img
                            src="/assets/images/messageIcon.svg"
                            alt=""
                            className="w-16"
                        />
                        <h2 className="font-medium text-xl mt-3 w-9/12">
                            Any Question or remarks? Just write us a message!
                        </h2>
                        <p className="w-9/12 font-light text-sm mt-2">
                            Fill up the form and our team will get back to you
                            within 24 hours
                        </p>
                    </div>
                    <div className="flex flex-col text-sm">
                        <img
                            src="/assets/images/mapIcon.svg"
                            alt=""
                            className="w-16"
                        />
                        <p
                            style={{ color: colors.melon }}
                            className="mt-3 text-base "
                        >
                            <a href="/">VpnPriceComparison.com</a>
                        </p>
                        <p className="mt-2">
                            Dorrat khalda complex, Fourth floor <br />
                            <b>Amman, Jordan, 11831</b>
                        </p>
                        <p className="mt-1">P.O Box 217, ZipCode 11831</p>
                        <p className="mt-1">
                            Phone:{" "}
                            <span className="font-medium">
                                +962 (06) 2000 102 (Ext: 4866)
                            </span>
                        </p>
                        <p className="mt-1">
                            Email:{" "}
                            <a href="mailto:info@vpnpricecomparison.com">
                                info@vpnpricecomparison.com
                            </a>
                        </p>
                    </div>
                </div>
                <div
                    style={{ backgroundColor: "white" }}
                    className="w-fill lg:w-3/5 py-6 px-5 lg:p-6 rounded-5"
                >
                    <ContactUsForm
                        primaryColor="#fe895c"
                        secondaryColor="#161616"
                        classes={{
                            formClassName: styles["form"],
                            fieldWrapperClassName: styles["field-wrapper"],
                            fieldClassName: styles["field"],
                        }}
                    />
                </div>
            </div>
        </section>
    );
}
